{
    "YkNB3io6eeGc_qTfQYAn1": {
        "tag": "spawngood",
        "key": "YkNB3io6eeGc_qTfQYAn1",
        "position": {
            "x": 3,
            "y": 3,
            "z": 1
        }
    },
    "vjWm4hMtGs3RGz1tra_8l": {
        "tag": "spawngood",
        "key": "vjWm4hMtGs3RGz1tra_8l",
        "position": {
            "x": 3,
            "y": 4,
            "z": 1
        }
    }
}
